import { useLayoutEffect, useRef } from 'react';
import './author-sticker.css';

export const AuthorSticker = () => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const label = ref.current;
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (preference.matches || !window.IntersectionObserver || !label.animate) return;
    let animation;
    let finished = false;
    const settle = () => {
      finished = true;
      observer.disconnect();
      animation?.cancel();
      label.classList.remove('sticker-waiting', 'sticker-attaching');
    };
    const attach = () => {
      if (finished) return;
      finished = true;
      observer.disconnect();
      label.classList.remove('sticker-waiting');
      label.classList.add('sticker-attaching');
      animation = label.animate([
        { opacity: 0, transform: 'perspective(800px) translate3d(-12px,-18px,35px) rotateY(-32deg) rotateZ(-8deg)', offset: 0 },
        { opacity: 1, transform: 'perspective(800px) translate3d(0,-3px,12px) rotateY(-18deg) rotateZ(-4deg)', offset: .3 },
        { opacity: 1, transform: 'perspective(800px) translate3d(0,0,0) rotateY(2deg) rotateZ(-4deg)', offset: .78 },
        { opacity: 1, transform: 'perspective(800px) translate3d(0,0,0) rotateY(0) rotateZ(-4deg)', offset: 1 },
      ], { duration: 650, easing: 'cubic-bezier(0.23,1,0.32,1)' });
      animation.finished.then(() => label.classList.remove('sticker-attaching')).catch(() => {});
    };
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .35)) attach();
    }, { threshold: .35, rootMargin: '0px 0px -40px 0px' });
    label.classList.add('sticker-waiting');
    observer.observe(label);
    const changed = () => { if (preference.matches) settle(); };
    const keyboard = event => { if (event.key === 'Tab') settle(); };
    preference.addEventListener('change', changed);
    document.addEventListener('keydown', keyboard);
    return () => {
      settle();
      preference.removeEventListener('change', changed);
      document.removeEventListener('keydown', keyboard);
    };
  }, []);
  return <div ref={ref} className="author-paper-label" data-ink-static><span className="editorial-handnote">Дмитрий Фокеев</span><span>Автор курсов · дизайнер · преподаватель</span></div>;
};
